<script setup lang="ts">
import { isRouteLoading } from '@/utils/is-route-loading.ts';
</script>

<template>
  <transition name="motion-fade">
    <div
      v-if="isRouteLoading"
      aria-label="Loading page"
      aria-valuetext="Loading"
      class="bg-primary/20 pointer-events-none fixed inset-x-0 top-0 z-[1100] h-1 overflow-hidden"
      role="progressbar"
    >
      <span class="route-progress bg-primary block h-full w-full"></span>
    </div>
  </transition>
</template>

<style scoped>
.route-progress {
  transform: scaleX(0.35);
  transform-origin: left;
  animation: route-progress 1.1s var(--motion-ease-standard) infinite;
}

@keyframes route-progress {
  0% {
    transform: translateX(-100%) scaleX(0.35);
  }

  55% {
    transform: translateX(65%) scaleX(0.55);
  }

  100% {
    transform: translateX(220%) scaleX(0.25);
  }
}

@media (prefers-reduced-motion: reduce) {
  .route-progress {
    animation: none;
    transform: scaleX(1);
  }
}
</style>
